import { Text, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
});

export type UnavailablePageProps = {
  message: string;
};

export default function UnavailablePage({ message }: UnavailablePageProps) {
  const styles = useStyles();

  return (
    <main className={styles.root}>
      <Text as="h1" size={500} weight="semibold">
        Catering ordering unavailable
      </Text>
      <Text>{message}</Text>
    </main>
  );
}
